<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <div>
            <div class="headline">Products</div>
          </div>
          <v-spacer></v-spacer>
          <v-flex xs6>
            <cal-picker :label="labels.dateSearch" v-model="effDate" @input="queryInterProducts()"></cal-picker>
          </v-flex>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" :total-items="totalItems" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="index" :loading="loading">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td>{{ props.item.productId }}</td>
          <td class="text-xs-right">{{ props.item.productDesc }}</td>
          <td class="text-xs-right">{{ formatDate(props.item.effDate) }}</td>
          <td class="text-xs-right">{{ formatDate(props.item.endDate) }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" :review="checkAccess(['intermediaryReview','productReview'])" :remove="checkAccess(['intermediaryReview','productReview'])"
            @remove="doPromptRemove(props.item)" @review="doEdit(props.item)" :loading="loading"></table-action>
          </td>
        </template>
      </v-data-table>
      </v-card>
    </v-flex>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Intermediary Product? ({{deleteInterProduct}})
    </confirm>
    <v-dialog v-model="dialog" max-width="900px" persistent scrollable>
      <v-btn slot="activator" color="primary" dark class="mb-2" @click="doNew()" v-if="checkAccess(['intermediaryReview','productReview'])">
        Add Product
        <v-icon right>mdi-cube-outline</v-icon>
      </v-btn>
      <v-card>
        <v-card-title>
          <span class="headline">Products</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs6 v-if="newInterProduct">
                <v-autocomplete :label="labels.productType" v-model="appID" :items="appIDList" item-text="label" item-value="value" v-on:change="productList(appID)" :error-messages="errors.collect('productType')" data-vv-name="productType" :data-vv-as="labels.productType" v-validate="'required'"></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.productType}}</v-subheader>
                <div>{{appIDDesc}}</div>
              </v-flex>
              <v-flex xs6 v-if="newInterProduct">
                <v-autocomplete :label="labels.product" v-model="interProductForm.product" :items="productLists" item-text="label" item-value="value" :error-messages="errors.collect('product')" data-vv-name="product" :data-vv-as="labels.product" v-validate="'required'"></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.product}}</v-subheader>
                <div>{{productDesc}}</div>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <cal-picker :label="labels.effDate" v-model="interProductForm.effDate" :error-messages="errors.collect('effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="startDateValidation"></cal-picker>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <cal-picker :label="labels.endDate" v-model="interProductForm.endDate" :error-messages="errors.collect('endDate')" data-vv-name="endDate" :data-vv-as="labels.endDate" v-validate="endDateValidation" :min="interProductForm.effDate"></cal-picker>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="close">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import toDate from 'date-fns/toDate'
import { formatDisplayDate } from '@/utils/date'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      headers: [
        { text: 'Product Code', align: 'left', value: 'productId', sortable: false },
        { text: 'Product Description', align: 'right', value: 'productDesc', sortable: false },
        { text: 'Start Date', align: 'right', value: 'effDate', sortable: false },
        { text: 'End Date', align: 'right', value: 'endDate', sortable: false },
        TableConst.tableActionHeader
      ],
      labels: {
        productType: 'Product Type*',
        product: 'Product*',
        desc: 'Description*',
        effDate: 'Start Date*',
        endDate: 'End Date ',
        dateSearch: 'Effective Intermediary Product'
      },
      interProductForm: {
        inter: undefined,
        product: undefined,
        effDate: undefined,
        endDate: undefined
      },
      effDate: undefined,
      appID: undefined,
      appIDDesc: undefined,
      productDesc: undefined,
      interProducts: [],
      productLists: [],
      dialog: false,
      editedIndex: -1,
      totalItems: 0,
      loading: false,
      newInterProduct: true,
      submitting: false,
      today: new Date(),
      items: [],
      promptRemove: false,
      selectedInterProduct: undefined,
      deleteInterProduct: ''
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    startDateValidation() {
      return 'required'
    },
    endDateValidation() {
      return 'start_enddate:' + this.interProductForm.effDate
    },
    appIDList() {
      return this.$store.state.adminInter.intermediary.appIDList
    }
  },
  methods: {
    async queryInterProducts() {
      try {
        this.loading = true

        const apiURI = this.$store.state.adminInter.intermediary.menu.InterProducts
        const expand = {
          inter: this.inter,
          effDate: this.effDate
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        if (result.data) {
          this.totalItems = result.data.totalElements
          const { data } = result.data
          if (data) {
            // Format the data here
            this.items = []
            data.map((interProduct) => {
              const convertProduct = {
                inter: interProduct.inter,
                productId: interProduct.productId,
                productDesc: interProduct.productDesc,
                effDate: interProduct.effDate,
                endDate: interProduct.endDate
              }
              this.items.push(convertProduct)
            })
          } else {
            this.items = []
          }
        }
        this.loading = false
      } catch (err) {
        console.log(err)
        throw err
      }
    },
    async productList(AppID) {
      try {
        const apiURI = this.$store.state.adminInter.intermediary.menu.productList
        if (apiURI) {
          const expand = {
            appId: AppID
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.getProductLists = true
            this.productLists = data
          } else {
            this.getProductLists = false
          }
        }
      } catch (err) {
        throw err
      }
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(toDate(xDate))
      }
    },
    async doEdit(item) {
      try {
        if (this.checkAccess(['intermediaryReview'])) {
          const apiURI = this.$store.state.adminInter.intermediary.menu.InterProduct
          const expand = {
            inter: this.inter,
            product: item.productId,
            effDate: new Date(item.effDate)
          }
          if (apiURI) {
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.interProductForm.inter = data.interproduct.inter
              this.appID = data.interproduct.appID
              this.appIDDesc = data.interproduct.appIDDesc
              this.interProductForm.product = data.interproduct.productId
              this.productDesc = data.interproduct.productDesc
              this.interProductForm.effDate = data.interproduct.effDate
              this.interProductForm.endDate = data.interproduct.endDate
            }
            this.dialog = true
            this.newInterProduct = false
          }
        } else {
          this.$snotify.warning('You do not have access to this resource')
        }
      } catch (err) {
        throw err
      }
    },
    doNew() {
      this.resetMessages()
      this.doClearForm()
      this.newInterProduct = true
    },
    doClearForm() {
      this.resetMessages()
      this.appID = undefined
      this.appIDDesc = undefined
      this.interProductForm.product = undefined
      this.productDesc = undefined
      this.interProductForm.effDate = this.today
      this.interProductForm.endDate = undefined
    },
    close() {
      this.doClearForm()
      this.dialog = false
    },
    doSave() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newInterProduct) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.InterProductCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.interProductForm)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)
            this.close()
            // Redirect back to listing
            this.queryInterProducts()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.InterProductUpdate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.interProductForm)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)
            this.close()
            // Redirect back to listing
            this.queryInterProducts()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedInterProduct = data
        this.deleteInterProduct = data.productId + ' - ' + data.productDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.InterProductDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          inter: this.inter,
          product: this.selectedInterProduct.productId
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.queryInterProducts()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  created() {
    this.effDate = new Date()
    this.interProductForm.inter = this.inter
    Promise.all([this.queryInterProducts()])
  },
  props: ['inter'],
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
